import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Sauvegarder — disquette duotone */
export const SaveIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Étiquette menthe en bas */}
      <rect x="7" y="13" width="10" height="7" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Disquette */}
      <path
        d="M5 3.5h11l3 3v13a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 4 19.5V5a1.5 1.5 0 0 1 1.5-1.5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Volet supérieur */}
      <path d="M8 3.5v4h7v-4" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Étiquette contour */}
      <rect x="7" y="13" width="10" height="7" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Petit trait sur l'étiquette */}
      <path d="M9 16h6" stroke="hsl(var(--background))" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
SaveIcon.displayName = "SaveIcon";
